import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const EnrCancelationReason = Loadable(
    lazy(() =>
        import("./enrCancelationReason").then(({ EnrCancelationReason }) => ({
            default: EnrCancelationReason,
        }))
    )
);

export const enrCancelationReasonRoutes = [
    {
        path: "/enr-cancelation-reason",
        exact: true,
        element: (
            <AuthorizedRoute
                
                moduleIds={[ALLOWED_MODULES.ENR_CANCEL_REASON]}
            >
                <EnrCancelationReason />
            </AuthorizedRoute>
        ),
    },
];
